import { Modal } from 'ui';
import type { SlotStart } from 'features/calendar';
import { CreateReminderForm } from './create-reminder-form';

type P = {
  isOpened: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  slotStart?: SlotStart;
};

const CreateReminderModal = ({ isOpened, onCancel, onSuccess, slotStart }: P) => (
  <Modal isOpened={isOpened} onCancel={onCancel} title="Set Reminder" width="large">
    <Modal.HugContent>
      <CreateReminderForm onCancel={onCancel} onSuccess={onSuccess} slotStart={slotStart} />
    </Modal.HugContent>
  </Modal>
);

export default CreateReminderModal;
